export default __webpack_public_path__ + "static/media/128.cb5ec6c3.jpg";